<template>
  <meter-record-crud
    :allowed-fee-types="[1, 3]"
    page-title="电·暖 — 抄表明细台账"
    direct-usage-entry
  />
</template>

<script>
import MeterRecordCrud from './MeterRecordCrud.vue'

export default {
  name: 'MeterEnergyRecordElectricHeat',
  components: { MeterRecordCrud }
}
</script>
